import { Icon } from '@/components';
import { Input } from '@/components/ui/input';

export function SearchFilterTable({ globalFilter, setGlobalFilter, placeholder }: any) {
  return (
    <div className="relative flex w-full items-center lg:w-[280px]">
      <Input
        type="search"
        className="border-neutral-50 bg-white pr-8"
        placeholder={placeholder}
        value={globalFilter ?? ''}
        onChange={(e) => setGlobalFilter(e.target.value)}
      />
      <Icon
        name="search"
        className="text-muted-foreground absolute top-1/2 right-3 h-4 w-4 -translate-y-1/2 transform text-neutral-400"
      />
    </div>
  );
}
